import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from "feather-icons-react";
import bgImage from "../../../assets/images/app/bg-image.png";

//Import components

class HelpCenterGuides extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listData1: [
        { id: 1, line: 'Deciding to purchase' },
        { id: 2, line: 'List your space' },
        { id: 3, line: 'Landing an experience or adventure' },
        { id: 4, line: 'Top uses questions' },
      ],

      listData2: [
        { id: 1, line: 'Pricing & availability' },
        { id: 2, line: 'Booking settings' },
        { id: 3, line: 'Responding to enquiries & requests' },
        { id: 4, line: 'Snoozing or deactivating your listing' },
      ],

      listData3: [
        { id: 1, line: 'Updating your listing' },
        { id: 2, line: 'Neighbourhoods' },
        { id: 3, line: 'Listing photos & photography' },
        { id: 4, line: 'DigitCard Plus' },
        { id: 5, line: 'API-connected software' },
      ],

      listData4: [
        { id: 1, line: 'Getting paid' },
        { id: 2, line: 'Adding payout info' },
        { id: 3, line: 'Your payout status' },
        { id: 4, line: 'Donations' },
        { id: 5, line: 'Taxes' },
      ],

      listData5: [
        { id: 1, line: 'DigitCard safely' },
        { id: 2, line: 'DigitCard Experiences and Adventures' },
        { id: 3, line: 'Changing a reservation' },
        { id: 4, line: 'Cancelling a reservation' },
        { id: 5, line: 'Long-term reservations' },
      ],

      listData6: [
        { id: 1, line: 'Your profile' },
        { id: 2, line: 'Account security' },
        { id: 3, line: 'Identification & verifications' },
        { id: 4, line: 'Reviews' },
        { id: 5, line: 'Superhost status' },
      ],
      listData7: [
        { id: 1, line: 'Manage your profile' },
        { id: 2, line: 'Manage your security' },
        { id: 3, line: 'Manage your payments' },
        { id: 4, line: 'Manage your subscription' },
      ],
    };
  }

  componentDidMount() {
    document.body.classList = "";
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById("topnav");
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add("nav-sticky");
      } else {
        navBar.classList.remove("nav-sticky");
      }
    }
  };
  render() {
    return (
      <React.Fragment>

        <section
          className="bg-half-170 bg-light d-table w-100 d-print-none"
          style={{ background: `url(${bgImage}) center center` }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={12} className="text-center">
                <div className="pages-heading">
                  <h4 className="title mb-0"> Guides & Support</h4>
                </div>
              </Col>
            </Row>

            <div className="position-breadcrumb">
              <nav aria-label="breadcrumb" className="d-inline-block">
                <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>{" "}
                  {/* <li className="breadcrumb-item"><Link to="/helpcenter-overview">Help Center</Link></li>{" "} */}
                  <li className="breadcrumb-item active" aria-current="page">User Guide</li>
                </ul>
              </nav>
            </div>
          </Container>
        </section>

        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <section className="section">
          <Container>
            <Row>
              <Col lg={4} md={6} xs={12}>
                <h5>Getting started</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  {this.state.listData1.map((item, key) => (
                    <li key={key} className="mt-2">
                      <Link to="#" className="text-muted">
                        <i className="mdi mdi-arrow-right text-primary me-2"></i>
                        {item.line}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col lg={4} md={6} xs={12} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                <h5>Your calendar</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  {this.state.listData2.map((item, key) => (
                    <li key={key} className="mt-2">
                      <Link to="#" className="text-muted">
                        <i className="mdi mdi-arrow-right text-primary me-2"></i>
                        {item.line}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col
                lg={4}
                md={6}
                xs={12}
                className="mt-4 mt-lg-0 pt-2 pt-lg-0 pt-2"
              >
                <h5>Your listings</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  {this.state.listData3.map((item, key) => (
                    <li key={key} className="mt-2">
                      <Link to="#" className="text-muted">
                        <i className="mdi mdi-arrow-right text-primary me-2"></i>
                        {item.line}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col lg={4} md={6} xs={12} className="mt-4 pt-2">
                <h5>How payouts work</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  {this.state.listData4.map((item, key) => (
                    <li key={key} className="mt-2">
                      <Link to="#" className="text-muted">
                        <i className="mdi mdi-arrow-right text-primary me-2"></i>
                        {item.line}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col lg={4} md={6} xs={12} className="mt-4 pt-2">
                <h5>Your reservations</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  {this.state.listData5.map((item, key) => (
                    <li key={key} className="mt-2">
                      <Link to="#" className="text-muted">
                        <i className="mdi mdi-arrow-right text-primary me-2"></i>
                        {item.line}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col lg={4} md={6} xs={12} className="mt-4 pt-2">
                <h5>Reservation help</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  <li className="mt-2">
                    <Link to="#" className="text-muted">
                      <i className="mdi mdi-arrow-right text-primary me-2"></i>
                      Help with a reservation or guest
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="#" className="text-muted">
                      <i className="mdi mdi-arrow-right text-primary me-2"></i>
                      Guest cancellations
                    </Link>
                  </li>
                </ul>
              </Col>

              <Col lg={4} md={6} xs={12} className="mt-4 pt-2">
                <h5>Your account</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  {this.state.listData6.map((item, key) => (
                    <li key={key} className="mt-2">
                      <Link to="#" className="text-muted">
                        <i className="mdi mdi-arrow-right text-primary me-2"></i>
                        {item.line}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col lg={4} md={6} xs={12} className="mt-4 pt-2">
                <h5>Management</h5>
                <ul className="list-unstyled mt-4 mb-0">
                  {this.state.listData7.map((item, key) => (
                    <li key={key} className="mt-2">
                      <Link to="#" className="text-muted">
                        <i className="mdi mdi-arrow-right text-primary me-2"></i>
                        {item.line}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Container>

          <Container className="mt-100 mt-60">
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="section-title mb-4 pb-2 text-center">
                  <h4 className="title mb-4">Frequently Asked Questions</h4>
                  <p className="text-muted para-desc mb-0 mx-auto">
                    Find answers to commonly asked questions below. If you can't find what you're looking for, please{" "}
                    <Link to="/contact" className="text-primary fw-bold">contact us</Link>.
                  </p>
                </div>

                <Row className="mt-4">
                  <Col md={6} xs={12} className="mt-4 pt-2">
                    <div className="d-flex">
                      <i>
                        <FeatherIcon
                          icon="help-circle"
                          className="fea icon-ex-md text-primary me-2 mt-1"
                        />
                      </i>
                      <div className="flex-1">
                        <h5 className="mt-0">
                          How does the application work?
                        </h5>
                        <p className="answer text-muted mb-0">
                          Our application is designed to provide a seamless experience.
                          Simply sign up, create your account, and start using our features
                          to manage your tasks efficiently.
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} xs={12} className="mt-4 pt-2">
                    <div className="d-flex">
                      <i>
                        <FeatherIcon
                          icon="help-circle"
                          className="fea icon-ex-md text-primary me-2 mt-1"
                        />
                      </i>
                      <div className="flex-1">
                        <h5 className="mt-0">
                          What is the main process to open an account?
                        </h5>
                        <p className="answer text-muted mb-0">
                          Opening an account is simple. Click on the sign up button,
                          fill in your details, verify your email address, and you're
                          ready to go.
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} xs={12} className="mt-4 pt-2">
                    <div className="d-flex">
                      <i>
                        <FeatherIcon
                          icon="help-circle"
                          className="fea icon-ex-md text-primary me-2 mt-1"
                        />
                      </i>
                      <div className="flex-1">
                        <h5 className="mt-0">
                          How to make unlimited data entries?
                        </h5>
                        <p className="answer text-muted mb-0">
                          With our premium plans, you can make unlimited data entries.
                          Simply upgrade your account to access this feature and enjoy
                          unrestricted usage.
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} xs={12} className="mt-4 pt-2">
                    <div className="d-flex">
                      <i>
                        <FeatherIcon
                          icon="help-circle"
                          className="fea icon-ex-md text-primary me-2 mt-1"
                        />
                      </i>
                      <div className="flex-1">
                        <h5 className="mt-0">
                          Is the application safe to use?
                        </h5>
                        <p className="answer text-muted mb-0">
                          Yes, absolutely. We use industry-standard encryption and security
                          measures to protect your data. Your information is safe and
                          secure with us.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>

          <Container className="mt-100 mt-60">
            <Row>
              <Col lg={6} md={6} xs={12}>
                <div className="d-flex align-items-center features feature-clean shadow rounded p-4">
                  <div className="icons text-primary text-center">
                    <i className="uil uil-envelope-check d-block rounded h3 mb-0"></i>
                  </div>
                  <div className="flex-1 content ms-4">
                    <h5 className="mb-1">
                      <Link to="#" className="text-dark">
                        Get in Touch !
                      </Link>
                    </h5>
                    <p className="text-muted mb-0">
                      This is required when, for text is not yet available.
                    </p>
                    <div className="mt-2">
                      <Link to="#" className="btn btn-sm btn-soft-primary">
                        Submit a Request
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>

              <Col lg={6} md={6} xs={12} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div className="d-flex align-items-center features feature-clean shadow rounded p-4">
                  <div className="icons text-primary text-center">
                    <i className="uil uil-webcam d-block rounded h3 mb-0"></i>
                  </div>
                  <div className="flex-1 content ms-4">
                    <h5 className="mb-1">
                      <Link to="#" className="text-dark">
                        Start a Meeting
                      </Link>
                    </h5>
                    <p className="text-muted mb-0">
                      This is required when, for text is not yet available.
                    </p>
                    <div className="mt-2">
                      <Link to="#" className="btn btn-sm btn-soft-primary">
                        Start Video Chat
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default HelpCenterGuides;
